import type { RequestQuoteGlobals } from "~/features/request-quote-dialog/types";
export type RequestQuoteLoadState = {
  status: "idle";
  data: null;
  message: null;
} | {
  status: "loading";
  data: null;
  message: string;
} | {
  status: "error";
  data: null;
  message: string;
} | {
  status: "ready";
  data: RequestQuoteGlobals;
  message: null;
};

/** Resolve SWR's independent values into one exhaustive state for accessible rendering. */
export function resolveRequestQuoteLoadState(input: {
  shouldLoad: boolean;
  data?: RequestQuoteGlobals | null;
  error?: unknown;
  isLoading: boolean;
}): RequestQuoteLoadState {
  if (!input.shouldLoad) {
    return {
      status: "idle",
      data: null,
      message: null
    };
  }
  if (input.error) {
    return {
      status: "error",
      data: null,
      message: "Request-quote settings could not be loaded."
    };
  }
  if (input.isLoading || input.data === undefined) {
    return {
      status: "loading",
      data: null,
      message: "Loading request-quote settings…"
    };
  }
  if (!input.data) {
    return {
      status: "error",
      data: null,
      message: "Request-quote settings are unavailable."
    };
  }
  return {
    status: "ready",
    data: input.data,
    message: null
  };
}